import React, { useState } from "react";
import { Link } from "react-router-dom";
import SmilingMan from "../Assets/Images/purchase-life-img-new.png";
import TealAccordianArrowDown from "../Assets/Images/TealArrowIcon.svg";
import CapsuleImageVertical from "./CapsuleImageVertical/CapsuleImageVertical";
import { useTranslation } from "../Hooks/useTranslation"; // Import the hook
import "../Assets/Styles/HealthInsurance.css";

const HealthInsuranceHero = ({ pageName = null }) => {
  const translations = useTranslation(); // Get translations dynamically

  const [openModalIndex, setOpenModalIndex] = useState(null);

  const benefits = [
    {
      title: translations.provenExperience,
      description: translations.provenExperienceDescription,
      color: "border-[#53BCC8]",
    },
    {
      title: translations.flexibleProducts,
      description: translations.flexibleProductsDescription,
      color: "border-[#AFA07B]",
    },
    {
      title: translations.lastingCommitment,
      description: translations.lastingCommitmentDescription,
      color: "border-[#0D4248]",
    },
    {
      title: translations.prestige,
      description: translations.PrestigeDescription,
      color: "border-[#AFA07B]",
    },
  ];

  return (
    <div className="healthInsurance-section py-[6rem] lg:py-[6rem] md:py-[8rem]  bg-[#FAFAFA]">
      <div className="container healthinsurancemaindiv default-container">
        <div className="insurance-section items-center lg:pl-0 md:pl-2">
          {/* Left Section */}
          <div className="">
            <div className="max-w-[25rem] upperdivwhyaquire animate__animated animate__fadeInLeft mt-12 md:mt-0 lg:pl-7">
              <h1 className="text-xl  lg:text-3xl text-left lg:text-left lg:text-4xl font-bold lg:mb-4 text-black whyacqtext extra-title-heading">
                {translations.WhyChooseHeading}
              </h1>
              <div className="lg:block hidden">
                <p className="text-gray-600 mb-8 text-sm whydesc extra-para-vs">
                  {translations.WhyChooseDescription}
                </p>
              </div>
            </div>
            {/* Mobile View - Modal Trigger Buttons */}
            <div className="col3 block lg:hidden animate__animated animate__fadeInLeft pt-0 pr-0 mt-5">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex flex-col mb-4">
                  <button
                    onClick={() => setOpenModalIndex(index)}
                    className={`flex self-start font-semibold justify-center items-center w-auto px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-200 text-black ${benefit.color}`}
                  >
                    <div>{benefit.title}</div>
                    <img
                      src={TealAccordianArrowDown}
                      alt="Modal Trigger Icon"
                      className="ms-2"
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Center Image Section */}
          <div className="col2 relative">
            <CapsuleImageVertical image={SmilingMan} />
          </div>

          {/* Right Section */}
          <div className="col3 hidden lg:block animate__animated animate__fadeInRight ">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex flex-col mb-8 mt-8 pl-8">
                <h3
                  className="text-sm font-bold text-black benefitstitle mb-2 extra-title24"
                  dangerouslySetInnerHTML={{ __html: benefit.title }}
                ></h3>
                <p
                  className="text-gray-600 text-xs leading-relaxed benefitsdesc extra-para-vs"
                  dangerouslySetInnerHTML={{ __html: benefit.description }}
                ></p>
              </div>
            ))}
          </div>
        </div>

        {openModalIndex !== null && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 animate__animated animate__fadeIn"
            onClick={() => setOpenModalIndex(null)}
          >
            <div
              className="relative bg-white py-10 px-6 rounded-3xl shadow-2xl w-[300px] max-w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setOpenModalIndex(null)}
                className="absolute top-6 right-8"
              >
                ✖
              </button>
              <p
                className=" font-bold mb-4 mt-2 "
                dangerouslySetInnerHTML={{
                  __html: benefits[openModalIndex].title,
                }}
              ></p>
              <p
                className="text-gray-600 text-xs mb-5"
                dangerouslySetInnerHTML={{
                  __html: benefits[openModalIndex].description,
                }}
              ></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HealthInsuranceHero;
